import { DatePicker } from '@/components/ui/DatePicker';
import { FormGrid } from '@/components/ui/FormGrid';

interface DateRangeFieldsProps {
  from: string;
  to: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  fromLabel?: string;
  toLabel?: string;
  fromMax?: string;
  toMin?: string;
  className?: string;
}

export function DateRangeFields({
  from,
  to,
  onFromChange,
  onToChange,
  fromLabel = 'From',
  toLabel = 'To',
  fromMax,
  toMin,
  className,
}: DateRangeFieldsProps) {
  return (
    <FormGrid columns={2} className={className}>
      <DatePicker label={fromLabel} value={from} onChange={onFromChange} max={fromMax ?? (to || undefined)} />
      <DatePicker label={toLabel} value={to} onChange={onToChange} min={toMin ?? (from || undefined)} />
    </FormGrid>
  );
}
